import { confirmAlert } from "react-confirm-alert";
import { HiOutlineCheckCircle, HiOutlineXCircle } from "react-icons/hi";
import React from 'react';
import Modal from './Modal';
import { Button } from '../Form';
import { FiEye } from 'react-icons/fi';
import { MedicineDosageTable, OdontogramaSelectedTable } from '../Tables';
import { medicineData } from '../Datas';
import toast from "react-hot-toast";

const SelectedChartOdontogramaModal = ({closeModal, isOpen, datas, title, text, functions}) => {
    const [localDatas, setLocalDatas] = React.useState(datas.map(item => ({
        ...item,
        selected: false
    })));

    const handleSelectedForIndex = (index) => {
        setLocalDatas(prev => prev.map((item, i) => {
            if (i === index) {
                return { ...item, selected: !item.selected };
            }
            return item;
        }));
    };

    const selectAll = () => {
        setLocalDatas(prev => prev.map(item => ({
            ...item,
            selected: !prev.every(item => item.selected)
        })));
    }

    React.useEffect(() => {
        functions.setDatas(localDatas);
    }, [localDatas]);

    return (
        <Modal
            closeModal={closeModal}
            isOpen={isOpen}
            title="Dientes a seleccionar"
            width={'max-w-4xl'}
        >   
            {/* table charts selecteds */}
            <div className="flex-colo gap-6 overflow-x-hidden">
                <div className="w-full overflow-x-scroll">
                    <OdontogramaSelectedTable
                        data={localDatas}
                        functions={{
                            selected: handleSelectedForIndex,
                            selectAll: selectAll
                        }}
                    />
                </div>
            </div>

            {/* view Invoice */}
            <div className="flex w-full justify-end gap-2">
                <Button
                    label="Cancelar"
                    onClick={() => {
                        closeModal();
                    }}
                />
                <Button
                    label="Imprimir"
                    onClick={() => {
                        if (localDatas?.find((chart) => chart.selected !== false)) {
                            
                            confirmAlert({
                                customUI: ({ onClose }) => {
                                    return (
                                    <div className="custom-ui flex flex-col text-center gap-5 border border-gray-400 rounded-lg p-5 bg-white">
                                        <h1 className=" font-bold text-lg">
                                            {title}
                                        </h1>
                                        <p>
                                            {text}
                                        </p>
                                        <div className="flex flex-row gap-5 lg:gap-10">
                                            <Button label={"No"} Icon={HiOutlineXCircle} onClick={onClose} />
                                            <Button
                                                label={"Si"}
                                                Icon={HiOutlineCheckCircle}
                                                onClick={async () => {
                                                onClose();
                                                closeModal();
                                                functions.printOdontograma();
                                                }}
                                            />
                                        </div>
                                    </div>
                                    );
                                },
                                })
                        } else {
                            toast.error("Debe seleccionar al menos una pieza dental!", {
                                duration: 5000,
                            });
                        }
                    }}
                />
            </div>
        </Modal>
    );
};
 
export default SelectedChartOdontogramaModal